<template>
  <div class="customer-manager-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-user-solid"></i> Customer</span>
        <el-button
          style="float: right"
          icon="el-icon-download"
          type="success"
          size="small"
          @click="downloadExcel()"
          >Excel</el-button
        >
      </div>
      <div class="table-data-customer">
        <div class="search-area">
          <el-input
            prefix-icon="el-icon-search"
            placeholder="Search Name, BankholderID, UID1"
            v-model="query.search"
            @input="searchEnter()"
          ></el-input>
        </div>

        <el-table v-loading="loadingCustomer" :data="dataCustomerTable" border>
          <el-table-column
            sortable
            prop="name"
            label="Name"
            header-align="center"
            align="center"
            width="300"
            fixed
          ></el-table-column>
          <el-table-column
            prop="bankholderID"
            label="Bankholder ID"
            header-align="center"
            align="center"
            width="220"
          >
            <template slot-scope="scope">
              <div
                v-html="
                  scope.row.bankholderID &&
                  bankholderIDRender(scope.row.bankholderID)
                "
              ></div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="uid1"
            label="UID1"
            header-align="center"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="uid2"
            label="UID2"
            header-align="center"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="distribution_code"
            label="Distribution Code"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            sortable
            prop="type"
            label="Type"
            header-align="center"
            align="center"
          ></el-table-column>
          <!-- <el-table-column sortable prop="status" label="Status" header-align="center" align="center"></el-table-column> -->
          <el-table-column
            prop="Id"
            label="Action"
            header-align="center"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.enduser_id">
                <el-button
                  icon="el-icon-success"
                  type="primary"
                  size="mini"
                  @click="
                    $router.push(
                      `/customer/view/${projectUID}/${scope.row.enduser_id}`
                    )
                  "
                  >View</el-button
                >
                <el-button
                  icon="el-icon-edit"
                  type="warning"
                  size="mini"
                  @click="
                    getCustomerToEdit(scope.row)
                  "
                  >Edit</el-button
                >
                <el-button
                  icon="el-icon-delete"
                  type="danger"
                  size="mini"
                  v-if="superRole"
                  @click="deleteCustomer(scope.row.enduser_id)"
                  >Del</el-button
                >
              </div>
              <div v-else>No end user id</div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-area">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentPageChange"
            :page-size="query.length"
            layout="prev, pager, next, jumper, sizes, total"
            :total="totalRecord"
          >
          </el-pagination>
        </div>
      </div>


    </el-card>
  </div>
</template>

<script>
//https://www.njleonzhang.com/vue-data-tables/#/en-us/event

import {
  getCustomerByProject,
  deleteCustomer,
  getCustomerExcel,
} from "@/api/customer";

export default {
  components: {},
  props: {
    projectUID: String,
    referrence: String,
  },
  computed: {
    superRole() {
      return this.roleAuth([this.role.spadmin]);
    },
  },
  data() {
    return {
      loadingCustomer: false,
      dataCustomerTable: [],
      dialogFormVisible: false,
      dialogTitle: "",
      actionForm: "",
      submiting: false,
      errMsg: "",
      totalRecord: 0,
      searchTimeout: null,
      customerData: {},
      query: {
        length: 20,
        start: 0,
        search: "",
      },
    };
  },
  methods: {
    getCustomerData() {
      this.loadingCustomer = true;
      getCustomerByProject(this.projectUID, this.query).then(
        ({ result, data }) => {
          this.loadingCustomer = false;
          if (result && data) {
            this.dataCustomerTable = data.record;
            this.totalRecord = data.total;
          }
        }
      );
    },
    getCustomerToEdit(item) {

      let ref = this.referrence === "project" ? "?ref=customer" : "";
      let version = item.versioning == "2" ? "/v2" : "";
      let url = `/customer${version}/edit/${item.enduser_id}/${item.type}${ref}`

      this.$router.push(url);
    },

    deleteCustomer(customer_uid) {
      this.$confirm(
        "Are you sure you want to delete this Customer, Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          deleteCustomer(customer_uid).then(({ result, message }) => {
            if (result) {
              this.$notify({
                title: "Success",
                message: `Delete Customer successfully`,
                type: "success",
                duration: 2000,
              });
              this.getCustomerData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    handleCurrentPageChange(page) {
      this.query.start = (page - 1) * this.query.length;
      this.getCustomerData();
    },
    handleSizeChange(size) {
      this.query.length = size;
      this.getCustomerData();
    },

    bankholderIDRender(bankholderData) {
      const bankList = bankholderData.split(",");
      const labelOpenTag = ` - <span class="el-tag el-tag--mini el-tag--light custom-tag-status`;
      const labelCloseTag = `</span>`;
      let htmlActive = [];
      let htmlClose = [];
      let htmlSuspend = [];

      bankList.forEach((bank) => {
        if (bank.search("active") >= 0) {
          htmlActive.push(
            `${bank
              .replace("[", labelOpenTag + `">`)
              .replace("]", labelCloseTag)}`
          );
        } else if (bank.search("closed") >= 0) {
          htmlClose.push(
            `${bank
              .replace("[", labelOpenTag + ` el-tag--danger">`)
              .replace("]", labelCloseTag)}`
          );
        } else {
          htmlSuspend.push(
            `${bank
              .replace("[", labelOpenTag + ` el-tag--warning">`)
              .replace("]", labelCloseTag)}`
          );
        }
      });

      return htmlActive.concat(htmlClose).concat(htmlSuspend).join(" <br>");
    },

    searchEnter() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.query.start = 0;
        this.getCustomerData();
      }, 800);
    },
    onSubmited() {
      this.getCustomerData();
    },
    gotoProject() {
      const route = this.$route;
      if (route.name === "ProjectCustomer") {
        window.location = `/project/${this.projectUID}?tab=project`;
      } else {
        this.$router.push(`/project/${this.projectUID}`);
      }
    },
    downloadExcel() {
      getCustomerExcel(this.projectUID);
    },
  },
  created() {
    this.getCustomerData();
  },
};
</script>

<style lang="scss">
.customer-manager-container {
  .pagination-area {
    margin-top: 20px;
  }

  .search-area {
    margin-bottom: 10px;
  }

  .custom-tag-status {
    margin: 2px;
    text-transform: capitalize;
  }
}
</style>